<template>
  <content-panel>
    <!-- 添加返回按钮区域 -->
    <div class="back-btn">
      <span @click="goBack">{{ '< 返回' }}</span> {{ isAdd ? '新增' : '编辑' }}上市清单
    </div>
    <div class="form-box">
      <el-form :inline="true" size="mini" label-width="120px" :model="addForm" :rules="rules" ref="addForm">
        <div class="title">基础信息</div>
        <div class="form-content">
          <el-form-item label="清单名称" prop="name">
            <el-input v-model.trim="addForm.name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="预计发布时间" prop="publishDate">
            <el-date-picker v-model="addForm.publishDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </div>
        <div class="title">各项工作负责人</div>
        <div class="form-content">
          <el-form-item label="基础信息负责人" prop="baseUser">
            <el-select v-model="addForm.baseUser" filterable multiple collapse-tags clearable>
              <el-option v-for="item in baseUserList" :key="item.userId" :label="item.name" :value="item.userId" />
            </el-select>
          </el-form-item>
          <el-form-item label="产品文案负责人" prop="productUser">
            <el-select v-model="addForm.productUser" filterable multiple collapse-tags clearable>
              <el-option v-for="item in productUserList" :key="item.userId" :label="item.name" :value="item.userId" />
            </el-select>
          </el-form-item>
          <el-form-item label="商品价格负责人" prop="goodsUser">
            <el-select v-model="addForm.goodsUser" filterable multiple collapse-tags clearable>
              <el-option v-for="item in goodsPriceUserList" :key="item.userId" :label="item.name" :value="item.userId" />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="flex-bt">
        <div class="title">选择商品</div>
        <el-button type="primary" size="mini" @click="isShowAdd = true">添加商品</el-button>
      </div>
      <div class="flex-bt">
        <el-form :inline="true" size="mini" :model="searchForm" label-width="120px" ref="searchForm">
          <el-form-item label="SPU编码/名称" prop="spu">
            <el-input v-model.trim="searchForm.spu" placeholder="请输入" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="商品编码/名称" prop="goods">
            <el-input v-model.trim="searchForm.goods" placeholder="请输入" @keyup.enter.native="onSearch" />
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </div>
      </div>
    </div>

    <table-panel ref="tablePanel">
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight + 8"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="spuCode" label="SPU编码" min-width="110" />
        <el-table-column prop="spuName" label="SPU名称" min-width="180" />
        <el-table-column prop="skuCode" label="商品编码" min-width="110" />
        <el-table-column prop="goodsName" label="商品名称" min-width="180" />
        <el-table-column prop="expecUpDate" label="预计上架时间" min-width="100" />
        <el-table-column label="操作" width="80" align="center">
          <template v-slot="scope">
            <el-button type="text" class="red-text-btn" @click="deleteRow(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <!-- <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div> -->
        <div class="confirm-box">
          <el-button size="mini" @click="goBack">取消</el-button>
          <el-button type="primary" size="mini" @click="onSave">保存</el-button>
        </div>
      </template>
    </table-panel>
    <addGoods :visible.sync="isShowAdd" v-if="isShowAdd" :listNo="listNo" @success="getTbaleData" />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import addGoods from './components/addGoods';
export default {
  // name: 'CreateList',
  mixins: [tableMixin, pagePathMixin],
  components: { addGoods },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      originalList: [],
      tableReload: true,
      addFormData: [],
      columnData: [],
      imgList: [],
      baseUserList: [],
      goodsPriceUserList: [],
      productUserList: [],
      loading: false,
      isShowAdd: false,
      statusOptions: [
        { label: '草稿', value: 'draft' },
        { label: '进行中', value: 'processing' },
        { label: '已完成', value: 'completed' },
        { label: '已取消', value: 'cancelled' },
      ],
      rules: {
        name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        publishDate: [{ required: true, message: '不能为空', trigger: 'change' }],
        baseUser: [{ required: true, message: '不能为空', trigger: 'change' }],
        productUser: [{ required: true, message: '不能为空', trigger: 'change' }],
        goodsUser: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      addForm: {
        name: '',
        publishDate: [],
        baseUser: [],
        productUser: [],
        goodsUser: [],
        publishDate: '',
      },
      searchForm: {
        spu: '',
        goods: '',
      },
      exportData: {},
    };
  },
  computed: {
    query() {
      return this.$route.query;
    },
    isAdd() {
      return Object.keys(this.query).length === 0;
    },
    listNo() {
      return this.$route.query.listNo;
    },
  },
  methods: {
    // 添加返回方法
    goBack() {
      this.$router.push('/newProduct/listingList');
      this.$store.dispatch('tagsView/delVisitedView', this.$route);
      this.$store.dispatch('tagsView/delCachedView', this.$route);
    },
    onSearch() {
      const { spu, goods } = this.searchForm;
      this.tableData.list = this.originalList.filter((item) => {
        // 判断SPU搜索条件
        const spuMatch = !spu || item.spuCode.toLowerCase().includes(spu.toLowerCase()) || item.spuName.toLowerCase().includes(spu.toLowerCase());

        // 判断商品搜索条件
        const goodsMatch = !goods || item.skuCode.toLowerCase().includes(goods.toLowerCase()) || item.goodsName.toLowerCase().includes(goods.toLowerCase());

        return spuMatch && goodsMatch;
      });
    },
    async init() {
      // this.loading = true;
      // try {
      //   const params = {
      //     pageNum: this.tableData.pageNum,
      //     pageSize: this.tableData.pageSize,
      //     ...this.addForm,
      //   };
      //   const res = await this.$q.newProduct.getProductLaunchList(params);
      //   if (res.code === 200) {
      //     this.tableData = res.data;
      //   }
      // } catch (error) {
      //   console.error(error);
      // } finally {
      //   this.loading = false;
      // }
    },
    // handleSizeChange(val) {
    //   this.tableData.pageSize = val;
    //   this.tableData.pageNum = 1;
    //   this.init();
    // },
    // handleCurrentChange(val) {
    //   this.tableData.pageNum = val;
    //   this.init();
    // },
    reset() {
      this.searchForm = {
        spu: '',
        goods: '',
      };
      this.tableData.list = [...this.originalList];
    },
    deleteRow(index) {
      this.$confirm('确认删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData.list.splice(index, 1);
        this.originalList.splice(index, 1);
      });
    },
    onSave() {
      // 检查是否有数据（已注释，允许商品数据为空）
      // if (!this.tableData.list || this.tableData.list.length === 0) {
      //   this.$message.warning('请先添加商品数据');
      //   return;
      // }
      // this.$refs.addForm.validate((valid) => {
      //   if (!valid) return;
        // 检查是否存在重复数据
        const duplicateItems = [];
        const seen = new Map();

        this.tableData.list.forEach((item) => {
          const key = `${item.skuCode}-${item.spuCode}`;
          if (seen.has(key)) {
            duplicateItems.push(item);
          } else {
            seen.set(key, item);
          }
        });

        if (duplicateItems.length > 0) {
          this.$message.error(`存在重复的商品数据：\n${duplicateItems.map((item) => `SPU编码：${item.spuCode}，商品编码：${item.skuCode}`).join('\n')}`);
          return;
        }

        let data = {
          listNo: this.listNo || '',
          spuList: this.tableData.list.map((v) => {
            return {
              skuCode: v.skuCode,
              spuCode: v.spuCode,
              expecUpDate: v.expecUpDate,
            };
          }),
          ...this.addForm,
        };
        this.$q.newProduct.productListSave({ data: data }).then((res) => {
          if (res.success) {
            this.$message.success(`${this.isAdd ? '新增' : '编辑'}成功`);
            this.goBack();
          }
        });
      // });
    },
    getTbaleData(data) {
      this.originalList = [...this.originalList, ...data];
      this.tableData.list = [...this.tableData.list, ...data];
    },
    getUserList() {
      this.$q.newProduct.productListGetUser().then((res) => {
        this.baseUserList = res.data.baseUsers;
        this.productUserList = res.data.productUsers;
        this.goodsPriceUserList = res.data.goodsPriceUsers;
        if (!this.isAdd) return;
        this.$set(this.addForm, 'baseUser', res.data.defaultBaseUser || []);
        this.$set(this.addForm, 'productUser', res.data.defaultProductUser || []);
        this.$set(this.addForm, 'goodsUser', res.data.defaultGoodsPriceUser || []);
      });
    },
    getEditData() {
      if (this.isAdd) return;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const data = new FormData();
      data.append('listNo', this.listNo);
      this.$q.newProduct
        .getNewProductListInfo({ data: data })
        .then((res) => {
          Object.assign(this.addForm, res.data);
          this.$set(this.addForm, 'baseUser', res.data.baseUsers || []);
          this.$set(this.addForm, 'productUser', res.data.productUsers || []);
          this.$set(this.addForm, 'goodsUser', res.data.goodsPriceUsers || []);
          this.originalList = [...this.originalList, ...res.data.itemAOS];
          this.tableData.list = [...this.tableData.list, ...res.data.itemAOS];
        })
        .finally((_) => {
          loading.close();
        });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    // this.$nextTick((_) => {
    //   // 先删除当前路由的缓存和访问记录
    //   this.$store.dispatch('tagsView/delVisitedView', this.$route);
    //   this.$store.dispatch('tagsView/delCachedView', this.$route);

    //   // 重新添加更新后的路由信息
    //   this.$store.dispatch('tagsView/addVisitedView', {
    //     ...this.$route,
    //     meta: {
    //       ...this.$route.meta,
    //       title: (this.isAdd ? '新增' : '编辑') + '上市清单',
    //     },
    //   });
    // });
    this.getEditData();
    this.getUserList();
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped>
// 添加返回按钮样式
.back-btn {
  font-size: 14px;
  color: #333;
  margin-bottom: 15px;
  display: inline-block;

  span {
    color: #b2b2b2;
    margin-right: 5px;
    cursor: pointer
  }
}

.title {
  color: #0BB78E;
  // font-size: 15px;
}

.form-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}
// .flex-bt {
//   >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
//     width: 150px !important;
//   }
// }

.flex-bt {
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 10px
}

.form-content {
  margin: 10px 0 30px 0
}

.flex-bt {
  >>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0
  }
}

.confirm-box {
  text-align: center
}

>>> .table-panel-header-bottom {
  padding-bottom: 0 !important
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}
</style>
